module.exports = __webpack_public_path__ + "img/banner.c4d4db7c.png";